export { default, md } from './Markdown'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Markdown/index.js